import React, { Fragment } from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';

import { SITE_ROOT_URL } from '../constants/endpoints';
import Page from './Page';

import { Container } from '../styles/Container';
import { Heading } from '../styles/Heading';
import { size } from '../styles/helpers/variables';
import { dynamicFontSize } from '../styles/helpers/mixins';

const OrderConfirmationPage = props => {
  const { location } = props;
  const { state } = location;
  const { order } = state;
  const { cart, purchasePage } = order;
  const { imageUrl, orderNumber, email, firstName } = purchasePage;
  const items = cart.cart.length ? cart.cart : [];

  return (
    <Page title="Tack för din order!" bgImg={`${SITE_ROOT_URL}${imageUrl}`} noBreadcrumbs>
      <Container bgColor="transparent" style={{ paddingTop: '0', paddingBottom: '0', minHeight: '60vh' }}>
        <InnerContainer>
          <WhiteContainer>
            <OrderHeading big margin="0 0 1rem">
              Tack
              {firstName ? `, ${firstName}` : ''}!
            </OrderHeading>
            <OrderText>
              Vi har skickat en orderbekräftelse till {email ? <span>{email}</span> : 'din mail'}.
              {orderNumber ? (
                <Fragment>
                  <br />
                  Ordernummer: <span>{orderNumber}</span>
                </Fragment>
              ) : (
                ''
              )}
            </OrderText>
            <List>
              {items.map(({ baseProductId, product }) => (
                <ListItem key={baseProductId} oneItem={items.length === 1}>
                  <ProductImage src={`${SITE_ROOT_URL}${product.mainImage.url}`} alt={product.name} />
                </ListItem>
              ))}
            </List>
          </WhiteContainer>
          <OrderText color="white" noMb>
            Behöver du hjälp, kontakta kundservice
            <br />
            <a href="tel:018650370">
              Telefon: <span>018-65 03 70</span>
            </a>
            <br />
            <a href="mailto:kundservice@valamagasinet.se">
              Mail: <span>kundservice@valamagasinet.se</span>
            </a>
          </OrderText>
        </InnerContainer>
      </Container>
    </Page>
  );
};

OrderConfirmationPage.defaultProps = {
  location: {}
};

OrderConfirmationPage.propTypes = {
  location: PropTypes.object
};

export const OrderHeading = styled(Heading)`
  margin: 0 0 0.5rem;
  @media screen and (min-width: ${size.large}px) {
    margin: 0 0 2rem;
  }
`;

export const InnerContainer = styled.div`
  padding: 55px 0;
  width: 100%;
  height: 100%;
  @media screen and (min-width: ${size.large}px) {
    padding: 85px 0 110px;
  }
`;

const List = styled.ul`
  padding-left: 0;
  margin: 0;
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;
`;

const ProductImage = styled.img`
  height: 100%;
  width: 100%;
  object-fit: contain;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
`;
const ListItem = styled.li`
  width: calc(100% / 3 - 32px);
  padding-top: calc(100% / 3 - 32px);
  margin: 0 16px 24px;
  position: relative;
  @media screen and (min-width: ${size.medium}px) {
    width: calc(100% / 3 - 48px);
    padding-top: calc(100% / 3 - 48px);
    margin: 0 24px 36px;
  }
  @media screen and (min-width: ${size.xLarge}px) {
    width: calc(100% / 4 - 48px);
    padding-top: calc(100% / 4 - 48px);
    margin: 0 24px 36px;
  }
  ${props =>
    props.oneItem &&
    css`
      width: 70%;
      padding-top: 70%;
      @media screen and (min-width: ${size.medium}px) {
        padding-top: calc(100% / 2 - 32px);
        width: calc(100% / 2 - 32px);
      }
    `};
`;

export const WhiteContainer = styled.div`
  width: 100%;
  margin: 0 auto 20px;
  max-width: 950px;
  background-color: white !important;
  display: flex;

  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  padding: 27px 17px;

  @media screen and (min-width: ${size.large}px) {
    margin: 0 auto 28px;
    padding: 57px 100px;
  }
`;

export const OrderText = styled.p`
  margin: 0;
  ${dynamicFontSize(16, 20)};
  font-weight: 300;
  line-height: 1.55;
  text-align: center;
  margin-bottom: 33px;
  a{ 
    text-decoration: none;
    color: inherit;
    cursor: pointer;
  }
  span {
    font-weight: 600;
  }
  ${props =>
    props.color &&
    css`
      color: ${props.color};
    `}
  @media screen and (min-width: ${size.large}px) {
    margin-bottom: 73px;
  }
  ${props =>
    props.noMb &&
    css`
      margin-bottom: 0;
      @media screen and (min-width: ${size.large}px) {
        margin-bottom: 0;
      }
    `}
`;

export default OrderConfirmationPage;



// WEBPACK FOOTER //
// ./src/pages/OrderConfirmationPage.js